import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
import frTranslations from './locales/fr/translation.json';
import deTranslations from './locales/de/translation.json';
import itTranslations from './locales/it/translation.json';
import ptTranslations from './locales/pt/translation.json';

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language
    fallbackLng: 'en',
    
    // Use saved language preference, fallback to English
    lng: localStorage.getItem('soldikeeper-language') || 'en',
    
    // Debug mode (set to false in production)
    debug: false,
    
    // Language resources
    resources: {
      en: {
        translation: enTranslations
      },
      es: {
        translation: esTranslations
      },
      fr: {
        translation: frTranslations
      },
      de: {
        translation: deTranslations
      },
      it: {
        translation: itTranslations
      },
      pt: {
        translation: ptTranslations
      }
    },
    
    // Interpolation options
    interpolation: {
      escapeValue: false // React already does escaping
    },
    
    // Language detection options
    detection: {
      // Order of language detection - start with specified language
      order: ['querystring', 'htmlTag'],
      
      // Don't cache to force fresh translation loading
      caches: [],
      
      // Optional htmlTag check for language
      checkWhitelist: true
    },
    
    // Namespace options
    ns: ['translation'],
    defaultNS: 'translation',
    
    // React options
    react: {
      // Wait for translations to be loaded before rendering
      useSuspense: true,
      // Bind i18n instance to react component
      bindI18n: 'languageChanged',
      // Bind store to react component
      bindI18nStore: 'added removed',
      // Default translation render mode
      transEmptyNodeValue: '',
      // Transform the key if translation is not found
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span']
    }
  });

export default i18n;
